import { useTranslation } from 'react-i18next';
import { UserQuery } from '../../generated/hooks';
import { Topics } from '../../components/ConversationSubjects/Topics';

type IProps = {
  user: UserQuery['user'];
};
const TopicsScreen = ({ user }: IProps) => {
  const { t } = useTranslation('surveysOverview');

  return <Topics heading={t('ReportAccess:topics')} dataIcom="heading-topics" user={user} />;
};

export default TopicsScreen;
